'use strict';

import lottie from 'lottie-web';
import animationData from '../../../src/assets/animations/animation-shore.json';

const $ = jQuery.noConflict();

$(function() {
	const brandAnimationGif = {
		init: function() {
			this.cacheDOM();

			if (!this.$sections.length) {
				return;
			}

			this.initLottie();
			this.bindObserver();
		},

		cacheDOM: function() {
			this.$sections = $('.js-brand-animation-gif');
			this.animations = new Map();
		},

		initLottie: function() {
			this.$sections.each((_, section) => {
				const container = section.querySelector('.js-brand-animation-lottie');

				if (!container) {
					return;
				}

				const animation = lottie.loadAnimation({
					container,
					renderer: 'svg',
					loop: true,
					autoplay: false,
					animationData,
				});

				this.animations.set(section, animation);
			});
		},

		bindObserver: function() {
			if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
				this.$sections.each((_, section) => {
					section.classList.add('is-visible');

					const animation = this.animations.get(section);

					if (animation) {
						animation.goToAndStop(animation.totalFrames - 1, true);
					}
				});

				return;
			}

			if (!('IntersectionObserver' in window)) {
				this.$sections.each((_, section) => this.reveal(section));

				return;
			}

			const observer = new IntersectionObserver((entries) => {
				entries.forEach((entry) => {
					if (entry.isIntersecting) {
						this.reveal(entry.target);
						observer.unobserve(entry.target);
					}
				});
			}, {threshold: 0.6});

			this.$sections.each((_, section) => observer.observe(section));
		},

		reveal: function(section) {
			section.classList.add('is-visible');

			const animation = this.animations.get(section);

			if (animation) {
				animation.play();
			}
		},
	};

	brandAnimationGif.init();
});
